import { render } from "./icon-remove.vue?vue&type=template&id=07b9e047&scoped=true"
import script from "./icon-remove.vue?vue&type=script&lang=js"
export * from "./icon-remove.vue?vue&type=script&lang=js"

import "./icon-remove.vue?vue&type=style&index=0&id=07b9e047&lang=scss&scoped=true"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b9e047"]])

export default __exports__